import http from '../_http_v2';

const result = {
  //default
  list: (m) => { return http.post(`console/wmds/result/list`, m); },
  detail: (m) => { return http.get(`console/wmds/result/${m.id}`); },

  //crud
  update: (m) => { return http.put(`console/wmds/result`, m); },
  delete: (m) => { return http.delete(`console/wmds/result/${m.id}`); },

  failed: (m) => { return http.get(`console/wmds/result/failed`, m); },
}

export default result

export { result }